module.exports = __webpack_public_path__ + "672193838d33aea408492a882afd7b7f.jpg";